import React, { useContext } from "react";
import { LangCtx, PayLoadCtx, CustomCtx } from "../../../lib/context";
import { Link, useLocation } from "react-router-dom";
import config from '../../../config.json'
import "../Styles.css";
import { parseDomain } from "parse-domain";

const DocWebSideNavLinks = (props) => {
  const location = useLocation();
  const { l } = useContext(LangCtx);
  const { payload } = useContext(PayLoadCtx);
  const { custom } = useContext(CustomCtx);
  const _domain = parseDomain(window.location.hostname);
  const url = window.location.hostname;

  console.log("DocWebSidenav");

  return (
    <>
      <ul className="flexMinHeightCol overFlowY">
        <li className="wsnItem">
          <Link
            to="/consultant-dashboard"
            className={
              location.pathname === "/consultant-dashboard"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/dashboard.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard}</span>
            </div>
            {/* <div className="linkCounter">
                        <span>15</span>
                    </div> */}
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/consultant-appointments"
            className={
              location.pathname === "/consultant-appointments"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/appointments-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.apptmnts}</span>
            </div>
            {/* <div className="linkCounter">
                        <span>15</span>
                    </div> */}
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/consultant-schedules"
            className={
              location.pathname === "/consultant-schedules"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/create-schedule-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.create_sched}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/consultant-uploads"
            className={
              location.pathname === "/consultant-uploads"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/uploads-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.waiting_uploads}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/consultant-invites"
            className={
              location.pathname === "/consultant-invites"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/invite-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.invite}</span>
            </div>
          </Link>
        </li>
        {(url.split('.')[0] === config.defaultdomian || _domain?.hostname === "localhost" || _domain?.hostname === "172.16.16.197") && <>
          <li className="wsnItem">
          <Link
            to="/corporate-config"
            onClick={props.hideMenu}
            className={
              location.pathname === "/corporate-config"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/analytics.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.dashboard_configuration}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/LicenseManagement"
            className={
              location.pathname === "/LicenseManagement"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/license.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.LicenseManagement}</span>
            </div>
          </Link>
        </li>
        </>}

        <li className="wsnItem">
          <Link
            to="/consultant-profile"
            className={
              location.pathname === "/consultant-profile"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/profile-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.my_profile}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <Link
            to="/consultant-settings"
            className={
              location.pathname === "/consultant-settings"
                ? "wsnLink wsnAcitve"
                : "wsnLink"
            }
          >
            <img
              src="/images/icons/settings-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.settings}</span>
            </div>
          </Link>
        </li>
        <li className="wsnItem">
          <a className='wsnLink' href="https://help.instavc.com/inconsult" target="_blank">
            <img src='/images/icons/play-button.png' alt='help' className='linkIcon invertWhite' />
            <div className="linkTxtBlock">
              <span>{l.help_center}</span>
            </div>
          </a>
        </li>
      </ul>
      <ul className="flexAutoCol btmGrp">
        <li className="wsnItem">
          <Link
            onClick={props.handleLogout}
            className={
              location.pathname === "/" ? "wsnLink wsnAcitve" : "wsnLink"
            }
          >
            <img
              src="/images/icons/logout-outline.png"
              className="linkIcon invertWhite"
              alt="icon"
            />
            <div className="linkTxtBlock">
              <span>{l.logout}</span>
            </div>
          </Link>
        </li>
      </ul>
    </>
  );
};

export default DocWebSideNavLinks;